<template>
  <div class="compare">
    <navigation customClickEvent @click="back">SVIP省钱对比</navigation>
    <main>
      <img src="./image/img_vs@2x.png" class="banner"/>
      <div class="core">
        <ul v-for="(item,index) in coreRights" :key="index" class="core-item">
          <li :class="{'black border-left':index===0}">{{item[0]}}</li>
          <li :class="{'yellow':index===0}">{{item[1]}}</li>
          <li :class="{'black border-right':index===0}">{{item[2]}}</li>
        </ul>
      </div>
      <div class="core">
        <ul v-for="(item,index) in otherRights" :key="index" class="core-item">
          <li :class="{'black border-left':index===0}">{{item[0]}}</li>
          <li :class="{'yellow':index===0}">{{item[1]}}</li>
          <li :class="{'black border-right':index===0}">{{item[2]}}</li>
        </ul>
      </div>
    </main>
    <footer>
      <nd-button class="btn" @click="showDialog">开通SVIP立享超值福利</nd-button>
    </footer>
    <!-- 活动弹窗 -->
    <withdraw-mao-popup ref="withdrawPop" @judgeOrder="judgeOrder" :status="status"/>
    <!-- 弹窗/有会员状态在支付中 -->
    <nd-dialog
      v-model="waitPayDialog"
      :footer="false"
      closeBtn
      class="activity-dialog"
    >
      <div class="activity-template-content ">
        <div class="title">温馨提示</div>
        <div class="content">
          <p>您有一笔未完成的{{vipsName[payStatusInfo.memberType]}}{{['SC_HY','SC1_HY'].includes(payStatusInfo.memberType)?'SVIP':'VIP'}}支付交易</p>
        </div>
        <div class="button-group">
          <nd-button
            class="dialog-btn"
            @click="find(payStatusInfo.goodsCd,'continue')"
          >继续支付</nd-button>
          <div
            class="giveup-btn"
            @click='giveup'
          >放弃支付 </div>
        </div>
      </div>
    </nd-dialog>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import { getKey } from '@/assets/utils'
import qs from 'qs'
export default {
  name: 'compare-withdraw',
  data () {
    return {
      'coreRights': [ // 核心权益
      ],
      'otherRights': [ // 其他权益
      ],
      dialog: false, // 点击开通时弹出
      waitPayDialog: false, // 继续支付弹窗
      creditAmount: [], // 授信信息
      payStatusInfo: {}, // 过期数据
      memberGoods: {}, // 弹窗信息
      vipsName: {
        'BC_M': '月卡', 
        'BC_HY': '半年卡', 
        'BC_Y': '年卡'
      },
      source: '', // 来源
      status: '6'
    }
  },
  watch: {
    dialog (value) {
      this.$report({
        id: 10121,
        args: {
          screen: 'compare_vip',
          visible: value ? 1 : 0,
          status: this.status
        }
      })
    }
  },
  async  created () {
    await Promise.all([this.memberInfoX(), this.compareSvipCommonX(), this.loanGuidPageX()])
    this.$emit('ready')
  },
  beforeRouteEnter (to, from, next) {
    if (from.path === '/withdraw/ssvip') {
      next(vm => {
        vm.source = from.fullPath
      }) 
    } else {
      next()
    }
  },
  methods: {
    ...mapActions('vip', [
      'memberInfo',
      'orderList',
      'orderCancel'
    ]), 
    ...mapActions('withdraw', [
      'compareSvipCommon',
      'loanGuidPage'
    ]), 
    //
    async  compareSvipCommonX () {
      const res = await this.compareSvipCommon()
      if (res.success) {
        const { otherRights, coreRights } = res.data || {}
        this.otherRights = otherRights || []
        this.coreRights = coreRights || []
      }
    },
    // svip 弹窗数据
    async loanGuidPageX () {
      const res = await this.loanGuidPage()
      if (res.success) {
        const { creditAmount, memberGoods, payStatusInfo } = res.data || {}
        this.memberGoods = memberGoods || {}
        this.creditAmount = creditAmount
        this.payStatusInfo = payStatusInfo || {}
      }
    },
    back () {
      if (this.source) {
        this.$router.go(-1)
      } else {
        const { couponSerialNos, couponType } = this.$route.query || {}
        let url = `/withdraw/ssvip?purchaseSVIP=withSvip`
        couponSerialNos && (url += `&couponSerialNos=${couponSerialNos}`)
        couponType && (url += `&couponType=${couponType}`)
        this.$router.push(url)
      }
    },
    // 开通
    showDialog () {
      this.$report({
        id: 10402
      })
      this.$refs['withdrawPop'].showMao()
    },
    // 跳转vip界面
    jumpVip (data) {
      let url = `/vip/index?target=svip&purchaseSVIP=${data}`
      this.$router.push(url)
    },
    // 初始化
    async  memberInfoX () {
      const { token } = this.$route.query || {}
      if (token) {
        const res = await this.memberInfo()
        let { memberGoodsGroupCd } = res.data || {}
        if (res.success) {
          // 如果不是会员 跳前置页
          if (memberGoodsGroupCd === 'SVIP') {
            this.$report({
              id: 10282,
              args: {
                status: this.status
              }
            })
            this.$router.push({ path: '/withdraw/index', query: { purchaseSuccessSVIP: 'success' } })
          }
        }
      }
    },
    // 放弃支付
    async giveup () {
      const res = await this.orderCancel({
        orderNo: this.payStatusInfo.exPaySerialNo
      })
      if (res.success) {
        this.waitPayDialog = false
      }
    },
    // 查看福利
    find (goodsCd, modeOfPayment) {
      let discountPriceValue = ''
      let mode = {}
      if (modeOfPayment === 'continue') {
        const { originalAmount, couponUseDetail, reducedAmount } = this.payStatusInfo || {}
        discountPriceValue = originalAmount
        mode = { couponUseDetail: JSON.stringify(couponUseDetail), modeType: 'continue', reducedAmount }
      }
      this.$refs['withdrawPop'].close()
      let host = encodeURIComponent(window.location.href)
      let gid = localStorage.getItem('gid')
      let token = getKey('userInfo', 'token') || ''
      let device = this.getDevice()
      const { discountPrice, memberGoodsGroupCd, memberGoodsCd } = this.memberGoods || {}
      const origin = process.env.VUE_APP_PAYURL
      const channel = getKey('channel') || ''
      const path = '/pay'
      const query = { 
        host,
        gid,
        token,
        channel,
        device,
        modeType: modeOfPayment,
        discountPrice: discountPriceValue || discountPrice,
        memberType: goodsCd || memberGoodsCd,
        memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
        status: this.status,
        ...mode
      }
      window.location.href = `${origin}${path}?${qs.stringify(query)}&refurl=${window.location.origin}`
      // this.$router.push(
      //   { path: '/vip/middle',
      //     query: {
      //       host,
      //       gid,
      //       token,
      //       device,
      //       modeType: modeOfPayment,
      //       discountPrice: discountPriceValue || discountPrice,
      //       memberType: goodsCd || memberGoodsCd,
      //       memberGoodsGroupCd: this.payStatusInfo.memberGoodsGroupCd || memberGoodsGroupCd || 'SVIP',
      //       status: this.status,
      //       ...mode
      //     } 
      //   }
      // )
    },
    // 是否有已存在订单
    async judgeOrder () {
      this.$report({
        id: 10275,
        args: {
          status: 'gou_mai',
          step: this.status
        }
      })
      this.$refs['withdrawPop'].close()
      const res = await this.orderList({ Status: '' })
      if (res.success) {
        let payStatusInfo = res.data || {}
        if (
          payStatusInfo &&
          payStatusInfo.payStatus &&
          payStatusInfo.payStatus === 'WAIT_PAY'
        ) {
          this.payStatusInfo = payStatusInfo
          this.waitPayDialog = true
        } else {
          this.find()
        }
      }
    },
    routerToVipProtocol () {
      this.$report({
        id: 10019,
        args: { position: 1 }
      })
      this.$refs['withdrawPop'].close()
      this.$router.push('/protocol/vip')
    }
  }
}
</script>
<style scoped lang="less">
@import "../../assets/less/mixin.less";

.compare{
  min-height: 100%;
  background: linear-gradient(180deg, #FF4633 0%, #FFFFFF 100%);
  display: flex;
  flex-direction: column;
  main{
    padding:30px 0 0;
    flex:1;
    .banner{
      display: block;
      margin:auto;
      width:696px;
      height:100px;
    }
    .core{
      width:690px;
      margin:20px auto 0;
      background: #FFFFFF;
      border-radius:20px;
      .core-item{
        display:flex;
        justify-content:space-between;
        height: 75px;
        align-items:center;
        li{
          flex:1;
          height: 100%;
          width: 156px;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
          padding-left:20px;
          display:flex;
          align-items:center;
        }
        li:nth-child(2){
          background: #FFFBF2;
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #8C4A00;
        }
        .black{
          background: #EEEEEE;
          font-size: 30px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
        }
        .border-left{
          border-radius:20px 0 0 0;
        }
        .border-right{
          border-radius: 0 20px 0 0;
        }
        .yellow{
          background: #FDF1D6 !important;
          font-size: 30px !important;
          font-weight: 500 !important;
          color: #8C4A00 !important;
        }
      }
    }
  }
  footer{
    margin-top:30px;
    width: 750px;
    height: 180px;
    background: #FFFFFF;
    box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.04);
    overflow: hidden;
  }
  .btn{
    width: 650px;
    height: 94px;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 47px;
    margin:28px auto 58px;
  }
   .dialog{
    position: relative;
    padding:20px 40px 50px;
    &-title{
      display: flex;
      justify-content:space-between;
      align-items: center;
      height: 45px;
      padding:0 !important;
      &-left{
        font-size: 32px;
        font-weight: 600;
        color: #333333;
      }
      &-right{
        font-size: 24px;
        color: #999999;
      }
    }
    .ink{
      display: inline-block;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFD8BC;
    }
    .expire-date{
      position: absolute;
      bottom:160px;
      right:50px;
      width:200px;
      padding:16px ;
      height:60px;
      line-height: 20px;
      background:url('./image/a@2x.png');
      background-size: 100% 100%;
      font-size: 20px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #FFD8BC;
      text-align: center;
    }
    .fu-li{
      margin-top:20px;
      width: 532px;
      font-size: 28px;
      color: #666666;
    }
    .flex{
      display: flex;
      justify-content:space-between;
      width: 540px;
      margin-top:18px;
    }
    .yuan-jia{
        color: #FFFFFF;
        font-size: 24px;
        text-decoration: line-through;
        padding-right: 20px;
      }
    &-img{
      width: 260px;
      height: 150px;
      background: #FFF7E5;
      border-radius: 10px;
      font-size: 22px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #763E12;
      display: flex;
      flex-direction: column;
      justify-content:center;
      align-items:center;
      text-align: center;
      >img{
        width:70px;
        height: 70px;
      }
    }
    .gou-mai{
      width: 440px;
      height: 80px;
      line-height: 80px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      border-radius: 40px;
      margin:34px auto 0 !important;
      font-size: 32px;
    }
    .xie-yi{
      font-size: 24px;
      color: #999999;
      text-align:center;
      margin-top:20px;
    }
  }
 .activity-dialog {
    border-radius: 30px;
    .default-content {
      background: linear-gradient(90deg, #fef6e4 0%, #fcd5ac 100%) !important;
      .activity-template-content {
        width: 620px;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 40px;

        .title {
          font-size: 32px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #763e12;
          line-height: 45px;
          text-align: center;
        }
        .content {
          font-size: 26px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763e12;
          line-height: 37px;
          padding: 20px 0;
        }
        .dialog-btn {
          width: 440px;
          height: 74px;
          line-height: 74px;
          margin-top: 30px;
          background: linear-gradient(270deg, #d79663 0%, #e4b378 100%);
        }
        .giveup-btn {
          height: 40px;
          font-size: 28px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #763e12;
          line-height: 40px;
          text-align: center;
          margin-top: 30px;
        }
        .xy-tips {
          color: #763e12;
          text-align: center;
          margin-top: 30px;
          .active {
            color: #763e12;
            text-decoration: underline;
          }
        }
      }
    }
  }
}
</style>